import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function WorkshopCurriculum() {
  const items = [{
    title: 'De ce te lovești mereu de aceleași tipare',
    desc: 'Vei înțelege de ce, chiar dacă ai încercat multe lucruri să te schimbi, în viață, în relații și în relația cu banii continuă aceleași scenarii.'
  }, {
    title: 'Ce sunt credințele limitative din subconștient',
    desc: 'Descoperi exact cum te sabotează aceste credințe fără să îți dai seama, blocându-ți abundența, încrederea și liniștea interioară.'
  }, {
    title: 'O tehnică practică pe care o poți folosi în seara asta',
    desc: 'Înveți cum să identifici și să începi să transformi o credință care te ține pe loc. Nu teorie — un exercițiu pe care îl aplici imediat.'
  }, {
    title: 'O meditație ghidată live, împreună',
    desc: 'Participi la o meditație care îți aduce pacea minții și te conectează cu o stare interioară din care lucrurile bune vin mai natural.'
  }, {
    title: 'Primul pas concret către o viață mai abundentă',
    desc: 'Pleci cu claritate asupra direcției. Fără să mai aștepți un moment perfect care nu vine niciodată.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-2178">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2179">
        <SectionHeading title="Ce vei descoperi concret în aceste 90 de minute" data-id="element-2180" />

        <div className="space-y-5 mb-16" data-id="element-2181">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-2182">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-2183">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-2184" />
              </div>
              <div data-id="element-2185">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-2186">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-2187">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2188">
          <CTAButton data-id="element-2189" />
        </motion.div>
      </div>
    </section>;
}